import React from "react";
import { Box } from "@mui/material";
import { PanelModel } from "survey-core";
import { ReactElementFactory, SurveyPanel } from "survey-react-ui";
import { COLORS } from "components/v3/Theme/colors";

interface ScrollablePanelProps {
  element: PanelModel;
}

const ScrollablePanel: React.FC<ScrollablePanelProps> = (props) => (
  <Box
    className="terms-scrollable-panel"
    sx={{
      border: `1px solid ${COLORS.GRAY}`,
      borderRadius: "24px",
      backgroundColor: COLORS.WHITE,
      maxHeight: { xs: "100%", md: "55vh" },
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      minHeight: 0
    }}
  >
    <Box
      className="terms-scrollable-panel__content"
      sx={{
        flexGrow: 1,
        overflowY: "auto",
        height: "100%",
        minHeight: 0,
        width: "98%"
      }}
    >
      <SurveyPanel {...props} />
    </Box>
  </Box>
);

ReactElementFactory.Instance.registerElement("panel", (props: any) => {
  if (props.element && props.element.name === "panel-intro") {
    return <ScrollablePanel {...props} />;
  }
  return React.createElement(SurveyPanel, props);
});

export default ScrollablePanel;
